import { Auth } from "aws-amplify";
import axios from "axios";
import Encoding from "encoding-japanese";
import { saveAs } from "file-saver";
import imsrconfig from "./imsr-exports.js";

async function imsrGetApi(apiname, params) {
  try {
    const url = imsrconfig.endpoint + imsrconfig.stage + apiname;
    const { idToken } = await Auth.currentSession();
    const headers = {
      Authorization: idToken.jwtToken,
    };
    const res = await axios.get(url, {
      params: params,
      headers: headers,
    });
    return res.data.data;
  } catch (e) {
    if (imsrconfig.stage == "main") {
      console.log("imsrGetApi:", e.response); // eslint-disable-line no-console
    }
    if (axios.isAxiosError(e)) {
      if (e.response.status !== undefined && e.response.data !== undefined) {
        throw { status: e.response.status, message: e.response.data.message };
      } else throw { status: 500, message: "System Error" };
    } else {
      throw { status: 500, message: "System Error" };
    }
  }
}

async function imsrPostApi(apiname, params) {
  try {
    const url = imsrconfig.endpoint + imsrconfig.stage + apiname;
    const { idToken } = await Auth.currentSession();
    const headers = {
      "Content-Type": "application/json",
      Authorization: idToken.jwtToken,
    };
    const res = await axios.post(url, params, {
      headers: headers,
    });
    return res.data.data;
  } catch (e) {
    if (imsrconfig.stage == "main") {
      "imsrPostApi:", e.response;
    }
    if (axios.isAxiosError(e)) {
      if (e.response.status !== undefined && e.response.data !== undefined) {
        throw { status: e.response.status, message: e.response.data.message };
      } else throw { status: 500, message: "System Error" };
    } else {
      throw { status: 500, message: "System Error" };
    }
  }
}

async function imsrPutApi(apiname, params) {
  try {
    const url = imsrconfig.endpoint + imsrconfig.stage + apiname;
    const { idToken } = await Auth.currentSession();
    const headers = {
      "Content-Type": "application/json",
      Authorization: idToken.jwtToken,
    };
    const res = await axios.put(url, params, {
      headers: headers,
    });
    return res.data.data;
  } catch (e) {
    if (imsrconfig.stage == "main") {
      console.log("imsrPutApi:", e.response); // eslint-disable-line no-console
    }
    if (axios.isAxiosError(e)) {
      if (e.response.status !== undefined && e.response.data !== undefined) {
        throw { status: e.response.status, message: e.response.data.message };
      } else throw { status: 500, message: "System Error" };
    } else {
      throw { status: 500, message: "System Error" };
    }
  }
}

async function imsrDeleteApi(apiname, params) {
  try {
    const url = imsrconfig.endpoint + imsrconfig.stage + apiname;
    const { idToken } = await Auth.currentSession();
    const headers = {
      Authorization: idToken.jwtToken,
    };
    const res = await axios.delete(url, {
      params: params,
      headers: headers,
    });
    return res.data.data;
  } catch (e) {
    if (imsrconfig.stage == "main") {
      console.log("imsrDeleteApi:", e.response); // eslint-disable-line no-console
    }
    if (axios.isAxiosError(e)) {
      if (e.response.status !== undefined && e.response.data !== undefined) {
        throw { status: e.response.status, message: e.response.data.message };
      } else throw { status: 500, message: "System Error" };
    } else {
      throw { status: 500, message: "System Error" };
    }
  }
}

async function imsrImageUploadApi(params) {
  const url = imsrconfig.imageUpload;
  const headers = {
    "Content-Type": "multipart/form-data",
  };
  const res = await axios.post(url, params, {
    headers: headers,
  });
  return res;
}

async function imsrGetImageApi(params) {
  const url = imsrconfig.endpoint + imsrconfig.stage + "/devices/image";
  const { idToken } = await Auth.currentSession();
  const headers = {
    Authorization: idToken.jwtToken,
  };
  const res = await axios.get(url, {
    params: params,
    headers: headers,
  });
  return res.data;
}

async function checkInvite(email, tenantId, code) {
  const url = imsrconfig.endpoint + imsrconfig.stage + "/invite";
  const headers = {
    "x-api-key": imsrconfig.apikey,
  };
  const res = await axios
    .get(url, {
      params: { email: email, tenantId: tenantId, code: code },
      headers: headers,
    })
    .catch((err) => {
      throw err;
    });
  return res.data;
}

async function createUser(params) {
  const url = imsrconfig.endpoint + imsrconfig.stage + "/invite";
  const headers = {
    "Content-Type": "application/json",
    "x-api-key": imsrconfig.apikey,
  };
  const res = await axios
    .put(url, params, {
      headers: headers,
    })
    .catch((err) => {
      throw err;
    });
  return res.data;
}

async function confirmSignUp(params) {
  try {
    const url = imsrconfig.endpoint + imsrconfig.stage + "/confirmSignUp";
    const headers = {
      "Content-Type": "application/json",
      "x-api-key": imsrconfig.apikey,
    };
    const res = await axios.post(url, params, {
      headers: headers,
    });
    return res.data.message;
  } catch (err) {
    if (imsrconfig.stage == "main") {
      console.log(err); // eslint-disable-line no-console
    }
    return err.response.data.message;
  }
}

async function getUserProject(params) {
  const res = await imsrGetApi("/projects/user", params);
  if (res.userRole == "admin") {
    return true;
  }
  return false;
}

async function getUser(params) {
  const res = await imsrGetApi("/users", params);
  if (res.userRole == "admin") {
    return true;
  }
  return false;
}

async function csvDownload(api, params, filename) {
  try {
    const url = imsrconfig.endpoint + imsrconfig.stage + api;
    const { idToken } = await Auth.currentSession();
    const headers = {
      Authorization: idToken.jwtToken,
    };
    const res = await axios.get(url, {
      params: params,
      headers: headers,
    });
    // endode
    const unicodeList = Encoding.stringToCode(res.data);
    const shiftJisCodeList = Encoding.convert(unicodeList, "sjis", "unicode");
    const shiftJisString = new Uint8Array(shiftJisCodeList);

    // save
    const fileName = filename + ".csv";
    let blob = new Blob([shiftJisString], { type: "text/csv;charset=sjis" });
    saveAs(blob, fileName);
  } catch (e) {
    if (imsrconfig.stage == "main") {
      console.log("imsrGetApi:", e.response); // eslint-disable-line no-console
    }
    if (axios.isAxiosError(e)) {
      if (e.response.status !== undefined && e.response.data !== undefined) {
        throw { status: e.response.status, message: e.response.data.message };
      } else throw { status: 500, message: "System Error" };
    } else {
      throw { status: 500, message: "System Error" };
    }
  }
}

export default {
  imsrGetApi,
  imsrPutApi,
  imsrPostApi,
  imsrDeleteApi,
  imsrImageUploadApi,
  imsrGetImageApi,
  checkInvite,
  createUser,
  getUserProject,
  getUser,
  csvDownload,
  confirmSignUp,
};
